export default __webpack_public_path__ + "static/media/serviceWave2.9bf15374.png";